import { useEffect } from "react";
import ChatModal from "../../Components/ChatModal/ChatModal";
import { ReactComponent as CloseIcon } from "../../Assets/icon/close.svg";
import { isMobile } from "react-device-detect";
import searchIcon from "../../Assets/images/searchIcon.png";
import { useState } from "react";
import ChatContacts from "../../Components/ChatContacts";
import { getRelationships } from "../../Services/Realtionship";
import UserPlus from "../../Assets/images/UserPlus.svg";
import { useNavigate } from "react-router-dom";
import MobilePopUp from "../../Components/MobilePopUp/MobilePopUp";
import ContentLoader from "../LoadingPage/ContentLoader";

function ContactSection({ onClose,
  onContactSelection,
  contactSelectionRelationAdvice,
}) {
  const navigate = useNavigate();
  const [activeCategoryId, setactiveCategoryId] = useState({
    id: 1,
    category: "All",
  });

  const [relations, setRelations] = useState([]);
  const [searchedName, setSearchedName] = useState("");
  const [loadRelation, setloadRelation] = useState(true);
  // Track which categories actually exist in user's relationships (excluding "All")
  const [availableCategories, setAvailableCategories] = useState([]);

  useEffect(() => {
    getRelationships(activeCategoryId?.category)
      .then((res) => {
        const list = Array.isArray(res) ? res : [];
        // Map backend v2 shape to legacy frontend shape to avoid regressions
        const mapped = list.map((r) => ({
          ...r,
          user1_id: r?.user_id ?? r?.user1_id ?? null,
          user2_id: r?.related_user_id ?? r?.user2_id ?? null,
          related_data: {
            relationship_type: r?.relationship_type ?? r?.related_data?.relationship_type ?? "",
            relationship_category: r?.relationship_category ?? r?.related_data?.relationship_category ?? "",
            relationship_length: r?.relationship_length ?? r?.related_data?.relationship_length ?? "",
            relationship_status: r?.relationship_status ?? r?.related_data?.relationship_status ?? "",
            relationship_goals: r?.relationship_goals ?? r?.related_data?.relationship_goals ?? null,
          },
        }));

        // If backend already filters by category, passthrough; otherwise filter client-side on mapped.related_data
        const filtered =
          activeCategoryId?.category && activeCategoryId.category !== "All"
            ? mapped.filter(
                (r) => r?.related_data?.relationship_category === activeCategoryId.category
              )
            : mapped;

        setRelations(filtered);

        // Derive categories present in current response
        const presentCats = Array.from(
          new Set(
            mapped
              .map((r) => r?.related_data?.relationship_category)
              .filter((c) => !!c && c !== "All")
          )
        );

        // Maintain a stable, human-friendly order using the predefined list
        const knownOrder = [
          "Friends",
          "Family",
          "Dating",
          "Marriage",
          "Workplace",
          "Roommates",
          "Sports",
          "Others",
        ];
        const presentSet = new Set([...(availableCategories || []), ...presentCats]);
        const nextAvailable = knownOrder.filter((c) => presentSet.has(c));
        // If available categories changed, update
        if (JSON.stringify(nextAvailable) !== JSON.stringify(availableCategories)) {
          setAvailableCategories(nextAvailable);
          // If current active category is no longer available, reset to All
          if (
            activeCategoryId?.category !== "All" &&
            !nextAvailable.includes(activeCategoryId?.category)
          ) {
            setactiveCategoryId({ id: 1, category: "All" });
          }
        }
      })
      .catch((err) => console.error(err))
      .finally((res) => setloadRelation(false));
  }, [activeCategoryId, searchedName]);

  // Build the category tabs: Always include All, then only categories present from data
  const categoryTabs = [
    { id: 1, category: "All" },
    ...availableCategories.map((cat, idx) => ({ id: idx + 2, category: cat })),
  ];

  const routoToAddReq = () => {
    onContactSelection({ type: "addNewContact" });
  };

  const onSearchChange = (e) => {
    setSearchedName(e?.target?.value);
  };

  return (
    <div className="contact-relationship-moadl-hero-container">
      <div className="contact-relationship-modal-head">
        <div className="contact-relationship-modal-title">
          Which relationship would you like to explore?
        </div>
        <div className="contact-relationship-modal-close" onClick={onClose}>
          <CloseIcon />
        </div>
      </div>
      {contactSelectionRelationAdvice && (
        <div style={{ color: "red" }}>{contactSelectionRelationAdvice}</div>
      )}
      <div className="contact-relationship-input-cntr">
        <img
          src={searchIcon}
          alt="searchIcon"
          className="contact-relationship-modal-search-icon "
        />
        <input
          type={"text"}
          placeholder={"Search by name"}
          className="contact-relationship-modal-search"
          onChange={onSearchChange}
        />
      </div>
      <div className="contact-relationship-modal-category-cntr">
        {categoryTabs?.map((category) => (
          <div
            id={category.id}
            key={category.id}
            className={
              "contact-relationship-modal-category-title" +
              (activeCategoryId?.id === category.id
                ? " contact-relationship-modal-category-title-txt-active-category"
                : "")
            }
            onClick={() => setactiveCategoryId(category)}
          >
            {category.category}
          </div>
        ))}
      </div>

      <div className="contact-relationship-modal-contact-list-cntr">
        <div className="chat-contacts-hero-container" onClick={routoToAddReq}>
          <div className="chat-contacts-initial chat-add-req-bg">
            <img src={UserPlus} alt="user" />
          </div>

          <div className="chat-contacts-name">{"Add Relationship"}</div>
        </div>
        {!loadRelation ? (
          relations
            ?.filter(
              (r) =>
                r?.first_name
                  ?.toLowerCase()
                  .includes(searchedName.toLowerCase()) ||
                r?.last_name?.toLowerCase().includes(searchedName.toLowerCase())
            )
            ?.map((rel, idx) => (
              <ChatContacts
                key={rel?._id || idx}
                initial={
                  rel?.first_name?.charAt(0)?.toUpperCase() +
                  "" +
                  rel?.last_name?.charAt(0)?.toUpperCase()
                }
                name={rel?.first_name + " " + rel?.last_name}
                img={rel?.profile_pic_url}
                onClick={() => {
                  onContactSelection(rel);
                  // Close the modal so chat is visible immediately
                  try { onClose && onClose(); } catch (_) {}
                }}
              />
            ))
        ) : (
          <ContentLoader />
        )}
      </div>
    </div>
  );
}
function ContactSelectionModal({
  isOpen,
  onClose,
  onContactSelection,
  contactSelectionRelationAdvice,
}) {
  return (
    <>
      {isMobile ? (
        <MobilePopUp
          isPopupVisible={isOpen}
          onClose={onClose}
          hideClose={true}
          children={
            <ContactSection
              onClose={onClose}
              onContactSelection={onContactSelection}
              contactSelectionRelationAdvice={contactSelectionRelationAdvice}
            />
          }
        />
      ) : (
        <ChatModal
          isOpen={isOpen}
          children={
            <ContactSection
              onClose={onClose}
              onContactSelection={onContactSelection}
              contactSelectionRelationAdvice={contactSelectionRelationAdvice}
            />
          }
          width={isMobile ? "98%" : "35%"}
          height={isMobile ? "95%" : "70%"}
          onClose={onClose}
        />
      )}
    </>
  );
}

export default ContactSelectionModal;
